import { styled } from '@mui/material'

export const Root = styled('div')`
  align-items: center;
  display: flex;
  height: calc(100vh - 236px);
  justify-content: center;
  width: 100%;
`
